import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { PANEL_SIDES } from "../../../common/consts";
export function addSearchQuery(_ref, payload) {
  var commit = _ref.commit;
  commit('PUSH_SEARCH_QUERY', {
    query: payload.query,
    side: payload.side
  });
}

/**
 * Will make a search request and dispatch setMainlist by default.
 * You can set your own dispatch via payload as a function.
 * That function will accept queryParams.
 *
 * @param getters
 * @param dispatch
 * @param payload
 */
export function search(_ref2, payload) {
  var getters = _ref2.getters,
    dispatch = _ref2.dispatch;
  var queryParams = {
    url: payload.url,
    params: _objectSpread(_objectSpread({}, payload.params), {}, {
      search: getters[payload.side + 'QueriesJson']
    })
  };
  if (payload.dispatch) {
    return payload.dispatch(queryParams);
  } else {
    return dispatch('splitPanel/mainlist/set', {
      data: queryParams,
      side: payload.side
    }, {
      root: true
    });
  }
}
export function searchPush(_ref3, payload) {
  var getters = _ref3.getters,
    dispatch = _ref3.dispatch;
  payload.dispatch = function (queryParams) {
    return new Promise(function (resolve) {
      dispatch('splitPanel/mainlist/push', {
        data: queryParams,
        side: payload.side
      }, {
        root: true
      }).then(function () {
        resolve();
      });
    });
  };
  return dispatch('search', payload);
}
export function updateSearchQuery(_ref4, payload) {
  var commit = _ref4.commit;
  commit('UPDATE_QUERY', {
    query: payload.query,
    side: payload.side
  });
}
export function removeSingleQuery(_ref5, payload) {
  var commit = _ref5.commit;
  commit('REMOVE_SINGLE_QUERY', {
    index: payload.index,
    side: payload.side
  });
}
export function clearAllQueries(_ref6, side) {
  var commit = _ref6.commit;
  commit('CLEAR_QUERIES', side);
}

/**
 * This action can be used when we want to rerun the search request.
 *
 * @param commit
 * @param side
 */
export function refreshMainlist(_ref7) {
  var commit = _ref7.commit;
  var sides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PANEL_SIDES;
  commit('INVOKE_SEARCH', sides);
}